import React from 'react';
import { Link } from 'react-router-dom';

// Страница 404 — несуществующий маршрут
export default function NotFound() {
  return (
    <div className="content" style={{ textAlign: 'center', paddingTop: 48 }}>
      <div style={{ fontSize: 52, marginBottom: 8 }}>🧭</div>
      <h1 style={{ margin: '0 0 6px' }}>404</h1>
      <p style={{ color: 'var(--text-dim)', marginTop: 0 }}>Такой страницы нет — она, возможно, была перемещена.</p>
      <Link
        to="/"
        style={{
          display: 'inline-block',
          background: 'var(--primary)',
          color: '#04150b',
          padding: '11px 18px',
          borderRadius: 12,
          fontWeight: 700,
          textDecoration: 'none',
          marginTop: 12,
        }}
      >
        На главную
      </Link>
    </div>
  );
}
